const initialState = {
  loading: false,
  loadingText: "",
};

const miscReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload.stat,
        loadingText: action.payload.text,
      };
    default:
      return state;
  }
};

export default miscReducer;
